import { usePostMutation } from "../../../typed-client/hooks/use-post-mutation"
import { UsePostMutationQueryOptions } from "../../../typed-client/types"

export function useSendCodeMutation(
  options?: UsePostMutationQueryOptions<"/api/UserAuthenticationFactor/SendCode">
) {
  return usePostMutation("/api/UserAuthenticationFactor/SendCode", options)
}
